import { TextField } from "@mui/material";
import React from "react";

const SearchBarV2 = ({ value, onChange, onSearch, config = {} }) => {
  const { size = "small", label = "Search", keyPress = true } = config;

  return (
    <div className="searchBar">
      <TextField
        size={size}
        label={label}
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (keyPress && e.key === "Enter") onSearch?.();
        }}
      />
    </div>
  );
};

export default SearchBarV2;
